export default __webpack_public_path__ + "static/media/logo_nl_white.111e1c7f.svg";